import React from "react";
import { useState, useEffect } from "react";
import Lightbox from "../Lightbox";
import coloredNoise from "../../assets/cursor/coloredNoise.gif";
import noise from "../../assets/cursor/bwNoise.gif";

function WorkCard({ id, image, title, genericDescription, companyDescription, video, showType, roles }) {
  // useStates
  const [isSeeMore, setSeeMore] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [toggleLabel, setToggleLabel] = useState('see more');
  const [descText, setDescText] = useState('');


  let hoverColour = "yellow";
  let lessDesc = "";
  const lengthOfDesc = 500;
  const desc = companyDescription;
  const seeMore = "see more";
  const seeLess = "see less";
  const bullet = "\u2022";
  const space = "\u0020";

  if (id % 2 == 0) {
    hoverColour = "pink";
  } else if (id % 3 == 0) {
    hoverColour = "blue";
  }

  /**
   * Open lightbox on thumbnail click.
   */
  const handleClick = () => {
    setIsModalOpen(true);
    setSeeMore(false);
    document.querySelector('.overlay').style.backgroundImage = `url(${noise})`; // make sure the cursor display shows the not-hover gif
  };
  
  /**
   * Close the modal.
   */
  const closeModal = () => {
    setIsModalOpen(false);
  };

  /** 
   * Set the lightbox description text.
  */
  useEffect(() => {
    // If the description is longer than the max length of the minimized description, display a shorter version of the description 
    if (desc.length > lengthOfDesc) {
      // Make sure we cut off the description at a space
      lessDesc = desc.substring(0, desc.indexOf(" ", lengthOfDesc)) + "...";
      setDescText(lessDesc);
    } else {
      // desc short enough!
      setDescText(desc);
      setToggleLabel("");
    }
  }, []);
  
  /**
   * Toggle lightbox description text between "show more" and "show less" states.
   */
  const toggleMore = () => {
    // Set description and see more/see less label depending on if open or closed
    if (isSeeMore) {
      setDescText(desc.substring(0, desc.indexOf(" ", lengthOfDesc)) + "...");
      setToggleLabel(seeMore);
    } else {
      setDescText(desc);
      setToggleLabel(seeLess);
    }

    setSeeMore(!isSeeMore);
  };

  /**
   * Monitor when the esc key is pressed and close the menu
   */
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isModalOpen) {
        setIsModalOpen(false);
      }
    };
  
    window.addEventListener('keydown', handleKeyDown);
  
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);

  /**
   * Display the hover cursor display. Here to fix bug with cursor hover not unhovering when lightbox opens.
   */
  const showHover = () => {
    document.querySelector('.overlay').style.backgroundImage = `url(${coloredNoise})`;
  }

  /**
   * Hide the hover cursor display. Here to fix bug with cursor hover not unhovering when lightbox opens.
   */
  const hideHover = () => {
    document.querySelector('.overlay').style.backgroundImage = `url(${noise})`;
  }

  return (
    <div className='work-card' onClick={handleClick} onMouseEnter={showHover} onMouseLeave={hideHover}>
      <div className={`image-container ${hoverColour}`}>
        <img src={image} alt={`project poster image for ${title}`} className='image' />
        <span className={`border-bottom ${hoverColour}`}></span>
        <span className={`border-left ${hoverColour}`}></span>  

        <Lightbox isOpen={isModalOpen} onClose={closeModal}>
          <>
            <div className="lightbox-left">
              <video
                  src={video}
                  className="work-video"
                  alt="lightboxVideo"
                  autoPlay
                  muted
                  loop
                  playsInline
              />
            </div>
            <div className="lightbox-right">
              <h2>{title}</h2>

              <div className="tag-container">
                {showType.map((type, index) => (
                  <div className="tag-button" key={index}>
                    {type}
                  </div>
                ))}
              </div>

              <p>
                {genericDescription}
              </p>

              <p>
                {descText} <span className="names see-more-label" onClick={toggleMore}>{toggleLabel}</span>
              </p>

              {Object.entries(roles).map(([role, names], index) => (
                <React.Fragment key={role}>
                  <hr className="divider" />
                  <p>
                    <span className="role">{role}</span>
                    <br />
                    <span className="names">{names.join(space + bullet + space)}</span>
                  </p>
                  
                  {/* Final <hr> */}
                  {index === Object.entries(roles).length - 1 && <hr className="divider" />}
                </React.Fragment>
              ))}
            </div>
          </>
        </Lightbox>
      </div>
    </div>
  )
}

export default WorkCard;